module.exports = __webpack_public_path__ + "static/media/Logo_Val-David_Couleur.111033d3.JPG";